<template>
<!-- ログイン 入力フォーム -->
<div id="login">
    <div id="content">
        <div class="inner center">
			<h2>パスワード再発行</h2>
			<div class="login_area"><!-- 入力 -->
				<p>パスワードをリセットして再発行します。<br>利用中のIDを入力して送信してください。</p>
				<dl id="form_area">
					<div class="flex justifycont-c">
					<dt><label for="username" class="form_label">ID</label></dt>
					<dd><input type="text" name="username" v-model="pass.id" id="username"></dd>
					</div>
				</dl>
				<div class="login_button"><!-- ボタン -->
					<button class="btn_login" @click="check();">送信</button>
				</div>
				<p class="error">{{pass.error}}</p>
				<div class="hosoku">
					<p class="hosoku_title"><fa icon="caret-right" class="fas fa-caret-right fa-fw"/>IDを忘れた方</p>
					<p class="hosoku_text">青森市ボランティアセンターまでお問い合わせください。</p>
					<p class="hosoku_text">お問合せ先：017-723-1340</p>
				</div>
			</div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import { reactive } from '@vue/reactivity';
import router from "../router";

export default {
    name: 'Password',  //コンポーネントに名前をつける
	setup () {
		const pass = reactive({
			id: "",
			error: "",
		});
		const check = async() => {
			if (pass.id) {
				pass.error = ""
				const res = await axios.put('/api/katudosya_data/rewrite', {username: pass.id});
				console.log(res)
				router.push({ path: '/PasswordRegist'});
			} else {
				pass.error = "IDを入力してください";
			}
		};

		return {
			pass,
			check,
		}
	},
};
</script>

<style scoped>
.login_area {
	width: 50%;
	margin: 0 auto;
}
@media screen and (max-width: 767px) {
	.login_area {
		width: 100%;
	}
}
.form_area dt {
    float:left;
    width: 100px;
    /* margin: 0 0 10px; */
}
.form_area dd {
    margin: 0 0 10px;
}

.form_area label.form_label {
    font-weight: bold;
    font-size: 1rem;
}
.form_area label.label_sub {
    font-weight: normal;
    font-size: 1rem;
}
.form_area input {
    font-size: 1rem;
}
</style>